import React, { useEffect, useState } from 'react'
import { Box } from '@ally/metronome-ui'
import styled from 'styled-components'
import BillboardChart from 'react-billboardjs'
import { pie } from 'billboard.js'
import 'billboard.js/dist/billboard.css'
import { useWidget } from './WidgetContext'

const StyledChartWrapper = styled(Box)`
  .bb-tooltip-container {
    min-width: 225px !important;

    table.bb-tooltip {
      opacity: 1;

      td {
        white-space: nowrap;
        padding-left: 7px !important;
      }
    }
  }
`

interface IndexedObj {
  [index: string]: string
}

export const dataSetColors: IndexedObj = {
  INT: '#FFB74D',
  FAS: '#D360E6',
  SIFI: '#B0F06B',
  RUP: '#3DB2DC',
  OTHER: '#9575CD',
}

export enum LegendTitles {
  FAS = 'Surprise Savings',
  RUP = 'Round Ups',
  SIFI = 'Recurring transfers',
  INT = 'Interest paid',
  OTHER = 'Other incoming money',
}

// istanbul ignore next
const chartConfig = {
  legend: {
    show: false,
  },
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  pie: {
    padding: 0,
    label: {
      format: (): string => '',
    },
  },
  size: {
    height: 110,
    width: 110,
  },
  tooltip: {
    format: {
      name: (id: string): string =>
        LegendTitles[id as keyof typeof LegendTitles],
      value: (value: string, ratio: number): string => {
        if (ratio < 0.01) {
          return '< 1%'
        }
        return `${(ratio * 100).toFixed(1)}%`
      },
    },
  },
  domProps: {
    'data-type': 'chart',
    'aria-hidden': true,
  },
}

const SavingsGrowthChart: React.FC = () => {
  const { stkSummaryData } = useWidget()
  const [columnData, setColumnData] = useState(
    stkSummaryData?.growthChart.monthToDateSummary?.dataSets,
  )

  const chartData = {
    columns: columnData,
    colors: dataSetColors,
    type: pie(),
  }

  useEffect(() => {
    // istanbul ignore next
    setColumnData(stkSummaryData?.growthChart.monthToDateSummary?.dataSets)
  }, [stkSummaryData])

  return columnData ? (
    <StyledChartWrapper>
      <BillboardChart
        className="stk-summary-growth-chart"
        data={chartData}
        legend={chartConfig.legend}
        padding={chartConfig.padding}
        size={chartConfig.size}
        tooltip={chartConfig.tooltip}
        pie={chartConfig.pie}
        domProps={chartConfig.domProps}
      />
    </StyledChartWrapper>
  ) : null
}

export default SavingsGrowthChart
